export default "__VITE_ASSET__CxcXe5WN__"